var _style, _defs, _g, _use, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneGlowCardAnimated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 43,
    viewBox: "-4 -5 32 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.screen{animation:screen 1.8s ease-in-out infinite}\n.rays{animation:rays 1.8s ease-out infinite;transform-box:view-box;transform-origin:11.8px 13px}\n.glow{animation:glow 1.8s ease-in-out infinite}\n@keyframes screen{0%,100%{opacity:.15}45%{opacity:.85}}\n@keyframes rays{0%,20%{opacity:0;transform:scale(.85)}45%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(1.15)}}\n@keyframes glow{0%,100%{opacity:0}45%{opacity:.55}}\n@media (prefers-reduced-motion:reduce){.screen,.rays,.glow{animation:none}.screen{opacity:.6}.glow{opacity:.3}}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pgcBlur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "pgcScreen",
    d: "M4.74409 14.685H8.98255C8.98255 15.4653 9.61509 16.0978 10.3954 16.0978H13.221C14.0013 16.0978 14.6338 15.4653 14.6338 14.685H18.8723V40.1158H4.74409V14.685Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pgcRays",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2053 4.28504C13.2053 5.02474 12.5481 5.5876 11.8084 5.5876C11.0687 5.5876 10.4115 5.02474 10.4115 4.28504V1.46142C10.4115 0.669377 11.0163 0 11.8084 0C12.6004 0 13.2053 0.669377 13.2053 1.46142V4.28504Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7227 8.45159C18.1997 7.92862 18.1325 7.06621 18.6555 6.54323L20.6521 4.54663C21.2123 3.98647 22.1135 3.94041 22.6737 4.50056C23.2339 5.06072 23.1878 5.96199 22.6276 6.52215L20.631 8.51875C20.108 9.04172 19.2456 8.97457 18.7227 8.45159Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.94304 4.50057C0.38288 5.06073 0.428946 5.96199 0.989106 6.52214L2.98571 8.51875C3.50868 9.04172 4.37109 8.97457 4.89407 8.45159C5.41704 7.92862 5.48419 7.06621 4.96122 6.54323L2.96462 4.54663C2.40446 3.98647 1.5032 3.94041 0.94304 4.50057Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "glow",
    filter: "url(#pgcBlur)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pgcScreen",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    className: "rays"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pgcRays"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    className: "screen",
    href: "#pgcScreen",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "rays"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pgcRays"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white",
    d: "M18.8723 11.8594H4.74409C3.18354 11.8594 1.91846 13.1245 1.91846 14.685V40.1158C1.91846 41.6763 3.18354 42.9414 4.74409 42.9414H18.8723C20.4328 42.9414 21.6979 41.6763 21.6979 40.1158V14.685C21.6979 13.1245 20.4328 11.8594 18.8723 11.8594ZM4.74409 14.685H8.98255C8.98255 15.4653 9.61509 16.0978 10.3954 16.0978H13.221C14.0013 16.0978 14.6338 15.4653 14.6338 14.685H18.8723V40.1158H4.74409V14.685Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGlowCardAnimated);
export default __webpack_public_path__ + "static/media/PhoneGlowCardAnimated.719dd798a34fcafb091ef2f74079a470.svg";
export { ForwardRef as ReactComponent };